<template>
  <field v-bind="$props">
    <div slot class="inner-wrapper">
      <input
        :id="'input' + _uid"
        :checked="value"
        type="checkbox"
        @input="
          save()
          $emit('toggled')
        "
      />
      <label :for="'input' + _uid" class="switch" />
      <label :for="'input' + _uid" class="text-value">
        {{ name }}
      </label>
    </div>
  </field>
</template>

<script>
import Field from './Field'
import ParseFunctions from '@/components/ParseFunctions'
import Constants from '@/components/Constants'
export default {
  components: {
    Field,
  },
  mixins: [ParseFunctions, Constants],
  props: {
    value: Boolean,
    title: String,
    name: String,
    description: String,
    dbname: String,
    teamId: String,
    watchlistId: String,
  },
  methods: {
    async save() {
      if (this.dbname) {
        let res
        if (this.teamId) {
          res = await this.updateTeamSettings(this.teamId, this.dbname, !this.value)
        } else if (this.watchlistId) {
          res = await this.setWatchlistNotificationSetting(this.dbname, !this.value, this.watchlistId)
        } else {
          res = await this.setUserSetting(this.dbname, !this.value)
        }
        if (res.status === 'ok') this.$emit('input', !this.value)
        else this.showServerError(res)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  cursor: pointer;
  /*&:hover {
            border-color: $blue;
        }*/
  .inner-wrapper {
    // border-bottom: 1px solid $flax-bloom;
    width: 100%;
    // margin-top: 10px;
    padding: 10px 0;
    align-items: center;
    justify-content: flex-start;
  }
}

label.switch {
  order: 1;
  display: inline-block;
  position: relative;
  height: 16px;
  width: 28px;
  // margin-bottom: 12px;
  background: #b2b6e1;
  cursor: pointer;
  font-size: 0;
  color: transparent;
  border-radius: 22px;
  transition: background-color 300ms ease;
  box-shadow: 0 4px 6px 0 rgba(23, 21, 63, 0.1);
  &:after {
    transition: right 300ms ease, background-color 300ms ease;
    content: '';
    display: block;
    height: 12px;
    width: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 14px;
    border-radius: 50%;
    background-color: #fff;
  }
}
input {
  order: 3;
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  //bottom: 0; //TODO ta linjka sprawia że ekran przesuwa się na sam dół
  margin-bottom: 9px;
}
input:checked + label.switch {
  background-color: $blue;
}
input:checked + label.switch:after {
  right: 2px;
  box-shadow: -2px 0px 0px rgba(0, 0, 0, 0.1);
}
label.text-value {
  order: 2;
  // flex-grow: 10; // fill remaining space to enable user to click anywhere
  flex: 0 10 auto;
  // color: $bluebell;
  font-family: $regular;
  font-size: 14px;
  // margin-bottom: 10px;
  margin-left: 12px;
  cursor: pointer;
}
input:checked ~ label.text-value {
  color: $black;
}
</style>
